export default "__VITE_ASSET__DBTwd0HS__"